const horaire221 = {
    'mondayOpen': '',
    'mondayClose': '',
    'tuesdayOpen': '',
    'tuesdayClose': '',
    'wednesdayOpen': '',
    'wednesdayClose': '',
    'thursdayOpen': '',
    'thursdayClose': '',
    'fridayOpen': '9:00',
    'fridayClose': '5:00',
    'saturdayOpen': '',
    'saturdayClose': '',
    'sundayOpen': '9:00',
    'sundayClose': '4:00',
};

export default horaire221;
